module.exports = __webpack_public_path__ + "static/media/img-db3fc21f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/baycare-logo.png
// module id = 5276
// module chunks = 39